export default "__VITE_ASSET__tgOQWFMn__"